
{
  "familyId": "TAA-WOORD-IDIOOM",
  "questions": [
    {
      "id": "TAA-WOORD-IDIOOM-001",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Welke zin in deze tekst betekent hetzelfde als 'iemand een hart onder de riem steken'?",
      "options": [
        "\"Je hebt goed geoefend. Je kunt dit!\"",
        "\"Maak je geen zorgen.\"",
        "\"Dank je, dat helpt echt.\"",
        "Bram steekt zijn duim op."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Bram ziet dat Lisa zenuwachtig is voor haar spreekbeurt. \"Maak je geen zorgen,\" zegt hij. \"Je hebt goed geoefend. Je kunt dit!\" Lisa glimlacht. \"Dank je, dat helpt echt.\" Bram steekt zijn duim op.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: idioom in context",
            "content": "'Een hart onder de riem steken' = iemand moed inspreken met woorden. Zoek de zin waarin Bram actief moed geeft door iets POSITIEFS te zeggen over wat Lisa kan.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_hart_riem_context",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Een hart onder de riem steken' betekent: iemand actief moed inspreken. 'Je hebt goed geoefend. Je kunt dit!' is precies dat — Bram benoemt waarom Lisa het wél kan. De andere opties zijn ofwel te algemeen, of een reactie, of een gebaar (geen gesproken aanmoediging).",
        "solutionSteps": [
          "Wat betekent het idioom? Iemand moed inspreken.",
          "Welke zin spreekt Lisa moed in? 'Je hebt goed geoefend. Je kunt dit!'",
          "'Maak je geen zorgen' is geruststellen, niet specifiek moed inspreken.",
          "'Dank je' is Lisa's reactie, geen aanmoediging van Bram.",
          "De duim opsteken is een gebaar — het idioom gaat over wat je zegt."
        ],
        "distractorExplanations": {
          "0": "Goed! Bram benoemt expliciet waarom Lisa het kan — dat is een hart onder de riem.",
          "1": "Dat is geruststelling, niet hetzelfde als moed inspreken. Een hart onder de riem = benoemen waarom iemand het wél kan.",
          "2": "Dit is Lisa's reactie, geen aanmoediging van Bram.",
          "3": "Dit is een gebaar. Het idioom gaat over wat iemand zegt om moed te geven."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-context-parafrase-fout", "label": "Geruststelling verward met moed inspreken", "optionIndex": 1 },
          { "id": "taa.idioom-context-parafrase-fout", "label": "Reactie verward met aanmoediging", "optionIndex": 2 },
          { "id": "taa.idioom-context-parafrase-fout", "label": "Gebaar verward met gesproken aanmoediging", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-002",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Waarom heeft Lisa 'vlinders in haar buik'?",
      "options": [
        "Omdat ze zenuwachtig is voor haar optreden.",
        "Omdat ze honger heeft.",
        "Omdat ze blij is met haar vriendin.",
        "Omdat ze ziek is."
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Lisa staat achter het gordijn te wachten. Zo meteen moet ze optreden voor de hele school. Haar handen trillen een beetje. Haar hart klopt snel. Ze voelt iets kriebelen in haar buik. \"Ik ben zo zenuwachtig!\" fluistert ze tegen haar vriendin.",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: oorzaak in de tekst",
            "content": "Lees de hele tekst. Wat staat er VOOR het kriebelen in de buik? Trillende handen, snel hart kloppen, en Lisa zegt zelf: 'Ik ben zo zenuwachtig'. Dat geeft de oorzaak.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_vlinders_context",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Vlinders in je buik' is figuurlijk voor een zenuwachtig of opgewonden gevoel. In de tekst zie je dat Lisa moet optreden, haar handen trillen, en ze zegt zelf: 'Ik ben zo zenuwachtig'. De oorzaak is dus duidelijk: zenuwen voor het optreden.",
        "solutionSteps": [
          "Wat betekent het idioom? Een zenuwachtig of opgewonden gevoel.",
          "Welke aanwijzingen geeft de tekst? Optreden, trillende handen, snel hart, 'ik ben zenuwachtig'.",
          "De oorzaak in de tekst = zenuwen voor het optreden."
        ],
        "distractorExplanations": {
          "0": "Goed! De tekst zegt expliciet: 'Ik ben zo zenuwachtig'. Vlinders in je buik = zenuwen.",
          "1": "Er staat niets over honger in de tekst. Vlinders in je buik is een figuurlijk gevoel, geen honger.",
          "2": "Lisa is op dit moment niet blij — ze is zenuwachtig voor haar optreden. Lees haar laatste zin nog eens.",
          "3": "Lisa is niet ziek. De symptomen (trillen, snel hart kloppen) komen door de zenuwen, niet door ziekte."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-context-oorzaak-fout", "label": "Verwart figuurlijk gevoel met honger", "optionIndex": 1 },
          { "id": "taa.idioom-context-oorzaak-fout", "label": "Mist context-aanwijzingen, kiest 'blij'", "optionIndex": 2 },
          { "id": "taa.idioom-context-oorzaak-fout", "label": "Verwart zenuwen met ziekte", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-003",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "matching",
      "question": "Koppel elke uitdrukking over werken aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": [
          "De handen uit de mouwen steken",
          "Op je lauweren rusten",
          "Iets op de lange baan schuiven",
          "Met de pet ernaar gooien"
        ],
        "rightItems": [
          "Hard aan het werk gaan",
          "Niets meer doen na een succes",
          "Een taak uitstellen",
          "Slordig werken"
        ],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: idioom-beeld",
            "content": "Maak een beeld bij elk idioom. Mouwen oprollen = klaar om te werken. Lauweren = oude prijzen (nu rust uit). Lange baan = ver weg = uitstellen. Pet ernaar gooien = onverschillig = slordig.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_werken_matching",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De handen uit de mouwen steken → hard aan het werk gaan. Op je lauweren rusten → niets meer doen na een succes. Iets op de lange baan schuiven → een taak uitstellen. Met de pet ernaar gooien → slordig werken.",
        "solutionSteps": [
          "Handen uit de mouwen = mouwen oprollen om aan de slag te gaan.",
          "Op je lauweren rusten = lauweren zijn oude prijzen — je rust uit op je successen.",
          "Op de lange baan schuiven = ver weg zetten = uitstellen.",
          "Met de pet ernaar gooien = onverschillig gooien = slordig werk leveren."
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.idioom-verwisseld-mand", "label": "Idiomen onderling verwisseld" }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-004",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "In welke zin in deze tekst gebeurt hetzelfde als bij 'van een mug een olifant maken'?",
      "options": [
        "\"Nu denkt de juf vast dat ik dom ben!\"",
        "\"Janneke heeft een 8!\"",
        "\"Maak het niet groter dan het is.\"",
        "\"Een 7? Dat is toch goed?\""
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "\"Mam, ik heb een 7 voor mijn toets!\" roept Tom. \"Een 7? Dat is toch goed?\" zegt zijn moeder. \"Ja, maar Janneke heeft een 8! Nu denkt de juf vast dat ik dom ben!\" Zijn moeder lacht. \"Tom, één punt verschil is niet erg. Maak het niet groter dan het is.\"",
            "instruction": "Lees de tekst",
            "source": "Voorbeeldtekst"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: transfer-patroon",
            "content": "'Van een mug een olifant maken' = iets kleins veel groter maken dan het is. Zoek de zin waarin iemand een KLEIN ding (één punt verschil) GROOT maakt (juf denkt dat ik dom ben).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_mug_olifant_transfer",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Van een mug een olifant maken' = van iets kleins iets groots maken. Tom maakt van één punt verschil (klein) de conclusie dat de juf hem dom vindt (groot). 'Nu denkt de juf vast dat ik dom ben!' is precies dezelfde overdrijving.",
        "solutionSteps": [
          "Wat doet 'van een mug een olifant maken'? Iets kleins groot maken.",
          "Welk klein ding is er? Eén punt verschil (7 vs 8).",
          "Welke zin maakt daar iets groots van? 'Nu denkt de juf vast dat ik dom ben!'",
          "Dat is dezelfde overdrijving."
        ],
        "distractorExplanations": {
          "0": "Goed! Tom maakt van één punt verschil een grote conclusie — dezelfde overdrijving.",
          "1": "Dat is gewoon een feit (Janneke heeft een 8). Daar wordt niets groter gemaakt dan het is.",
          "2": "Dat is juist het ADVIES tegen overdrijven, niet de overdrijving zelf.",
          "3": "Dat is een relativering door de moeder, geen overdrijving."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-transfer-mist-patroon", "label": "Verwart feit met overdrijving", "optionIndex": 1 },
          { "id": "taa.idioom-transfer-mist-patroon", "label": "Verwart advies-tegen met overdrijving", "optionIndex": 2 },
          { "id": "taa.idioom-transfer-mist-patroon", "label": "Verwart relativering met overdrijving", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-005",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "matching",
      "question": "Koppel elke uitdrukking aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Met de deur in huis vallen", "Iets door de vingers zien", "Op je tellen passen", "De knoop doorhakken"],
        "rightItems": ["Meteen ter zake komen", "Iets laten gaan / niet bestraffen", "Voorzichtig zijn", "Een beslissing nemen"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Check-strategie: uitdrukkingen onthouden", "content": "Probeer een beeld te maken bij elke uitdrukking. 'Met de deur in huis vallen' = je valt meteen naar binnen = je komt meteen ter zake. 'De knoop doorhakken' = je hakt de knoop door = je neemt een beslissing.", "icon": "lightbulb" } }],
      "conceptId": "idioom_matching",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "'Met de deur in huis vallen' = meteen ter zake komen. 'Iets door de vingers zien' = iets laten gaan. 'Op je tellen passen' = voorzichtig zijn. 'De knoop doorhakken' = een beslissing nemen.",
        "solutionSteps": ["Met de deur in huis vallen → meteen ter zake komen", "Iets door de vingers zien → iets laten gaan", "Op je tellen passen → voorzichtig zijn", "De knoop doorhakken → een beslissing nemen"]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-WOORD-IDIOOM-006",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "fill_in",
      "question": "Vul het juiste idioom in. Lisa heeft geen zin om te leren voor de toets. Ze _____ . (kies een uitdrukking met dezelfde betekenis als 'het uitstellen')",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "placeholder": "schuift het op de lange baan",
        "inputType": "text",
        "acceptedAnswers": [
          "schuift het op de lange baan",
          "schuift het op de lange baan.",
          "schuift het op de lange baan",
          "schuift het voor zich uit",
          "stelt het op de lange baan"
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: idioom voor uitstellen",
            "content": "Een lange baan = ver weg = je legt de taak ver vooruit = je stelt 'm uit. De uitdrukking is: 'iets op de lange baan schuiven'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_lange_baan_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het idioom voor 'uitstellen' is 'iets op de lange baan schuiven'. De volledige zin wordt: 'Ze schuift het op de lange baan.'",
        "solutionSteps": [
          "Wat betekent uitstellen? Iets ver vooruit leggen.",
          "Welk idioom past? 'Op de lange baan schuiven' — een lange baan is ver weg.",
          "Volledige zin: 'Ze schuift het op de lange baan.'"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-fill-letterlijk-gekozen", "label": "Letterlijke omschrijving gekozen i.p.v. idioom" }
        ]
      }
    },
    {
      "id": "TAA-WOORD-IDIOOM-007",
      "familyId": "TAA-WOORD-IDIOOM",
      "module": "Taalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "woordenschat",
      "subSkill": "woord_idioom",
      "questionType": "multiple_choice",
      "question": "Lees: 'Tom gooide het bijltje erbij neer toen het te moeilijk werd.'",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "mode": "two_step_judge",
        "step1": {
          "prompt": "Wordt deze uitdrukking letterlijk of figuurlijk bedoeld?",
          "options": ["Letterlijk", "Figuurlijk"],
          "correctIndex": 1
        },
        "step2_ifIndex": 1,
        "step2": {
          "prompt": "Wat betekent 'het bijltje erbij neergooien'?",
          "options": ["Opgeven, ergens mee stoppen", "Een echt bijltje weggooien", "Heel boos worden", "Hard werken"],
          "correctIndex": 0
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Letterlijk of figuurlijk?",
            "content": "Tom heeft geen echt bijltje. 'Het bijltje erbij neergooien' is een uitdrukking voor: opgeven, ergens mee stoppen omdat het te zwaar wordt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "idioom_bijltje_neergooien",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "taa.idioom-letterlijk-bijltje", "label": "Neemt 'bijltje' letterlijk" }
        ]
      },
      "feedback": {
        "explanationText": "'Het bijltje erbij neergooien' is figuurlijk en betekent: opgeven of stoppen. Stap 1: figuurlijk (Tom gooit geen echt bijltje weg). Stap 2: opgeven.",
        "solutionSteps": [
          "Stap 1: Tom heeft geen echte bijl → figuurlijk",
          "Stap 2: 'Bijltje erbij neergooien' = stoppen, opgeven",
          "Hier: Tom geeft op omdat het te moeilijk werd"
        ]
      }
    }
  ]
}
